(function($) {
    'use strict';

    let $body = $(document.body);

    $body.on('click', '.flyout-menu-wrp', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('flyout/hide');

    });


    if ( ! $('html').hasClass('menu-open') ) {

        $body.on('click', '.menu-toggle', function() {

            $('.flyout-menu-wrp').addClass('open');
            $('body').attr( 'data-pos', $(window).scrollTop() );
            $('html').addClass('menu-open');

        });

    } else {
        $body.trigger('flyout/hide');
    }

    class Flyout {
        constructor() {
            $body.on(
                'click',
                '.menu-close',
                this.flyout_hide,
            );
            $(document).on('flyout/hide', this.flyout_hide);
        }

        flyout_hide = () => {
            var scrolltop = $('body').attr( 'data-pos');
            $(window).scrollTop(scrolltop)
            $('.flyout-menu-wrp .flyout-menu-content').addClass('close');

            setTimeout(function() {
                $('.flyout-menu-wrp .flyout-menu-content').removeClass('close');
                $('.flyout-menu-wrp').removeClass('open');
                $('html').removeClass('menu-open');
            }, 500);
        };
    }

    new Flyout();

}(jQuery));

//# sourceMappingURL=header-navigation.js.map
